module.exports = __webpack_public_path__ + "img/pocket_en.51c3acd.jpg";